import React from "react";
import "./ProjectsContainer.css";
import ProjectCard from "./ProjectCard";

export default function ProjectsContainer() {
  return (
    <div className='projects-container'>
      <div className='title-bar'>My Projects</div>
      <div className='projects-inner-container'>
        <ProjectCard
          name={"Play Everywhere gaming service"}
          description={
            "Play Everywhere website is an imitation of gaming service website like Xbox Game Pass or Playstation Plus/Now. This project shows my front-end developement skills. " +
            " Website contains 5 pages: home page, quiz, summary, checkout and success. User after answering the initial quiz, gets the results and suggested plan to order."
          }
          languages={"REACT, GATSBY, TYPESCRIPT, STYLED COMPONENTS"}
          projectLink={"https://dovtutis-play-everywhere.netlify.app/"}
          codeLink={"https://github.com/Dovtutis/playEverywhere"}
        />
        <ProjectCard
          name={"Home Design Website"}
          description={
            "This webpage is an imitation of home design website built by using gatsby and react. It uses airtable CMS with which we change and get data on the runtime, Algolia search API for searching and GraphQL with GraphiQL IDE for data management. User can check for designs by categories, search for desgins, vote for them and read reviews."
          }
          languages={"REACT, GATSBY, GRAPHQL"}
          projectLink={"https://dovtutis-gatsby-design-site.netlify.app/"}
          codeLink={"https://github.com/Dovtutis/gatsbyDesignSite"}
        />
        <ProjectCard
          name={"Github User Search"}
          description={
            "Github user search WEB application is a single page application which allows user to login by using Auth0 authentication and authorization platform and search for Github " +
            "users to get various information about user, repositories, followers etc."
          }
          languages={"REACT, JS, STYLED COMPONENTS"}
          projectLink={"https://dovtutis-github-user-search.netlify.app/"}
          codeLink={"https://github.com/Dovtutis/github-user-search"}
        />
        <ProjectCard
          name={"Comfy Sloth Eshop"}
          description={
            "Comfy Sloth eshop website is an eshop built by using react. It has advanced filtering options for products, auth0 authentication system for login and signup and Stripe payments system." +
            " Website contains 5 pages: home page, about, products, cart and checkout."
          }
          languages={"REACT, JS, STYLED COMPONENTS"}
          projectLink={"https://dovtutis-comfy-sloth.netlify.app/"}
          codeLink={"https://github.com/Dovtutis/comfy-sloth-eshop"}
        />
        <ProjectCard
          name={"Meals Application"}
          description={
            "In this meals application user can browse through different food receipes, select them by different categories, add them to favorites and filter them by given specifications." +
            "This task was from Udemy React Native course. It was created by using React Native (Expo)."
          }
          languages={"REACT NATIVE, JS"}
          projectLink={"https://youtu.be/XHG6xaQHve8"}
          codeLink={"https://github.com/Dovtutis/foodAppRN"}
        />
        <ProjectCard
          name={"React Native Nintendo Eshop"}
          description={
            "React Native online shop application where user can browse through different items which are for sale, check them in detail, add to cart and order. User can add new " +
            "products, edit and delete them also check made orders in detail. Items and orders are stored in Firebase database. Users can create an account with which they can log" +
            " in. This task was from Udemy REACT Native course. It was created by using React Native (Expo)."
          }
          languages={"REACT NATIVE, JS"}
          projectLink={
            "https://www.youtube.com/watch?v=Fx0u5ssGZNQ&feature=youtu.be"
          }
          codeLink={"https://github.com/Dovtutis/eshopRN"}
        />
        <ProjectCard
          name={"Food Order Page"}
          description={
            "React Food Order application which allows to order meals from the restaurant. This task was from Udemy REACT course." +
            "Meals and orders data are stored in FireBase database. Usage of useEffect, useState, useRef, useContext, useReducer. Custom hooks implemented."
          }
          languages={"HTML, CSS, JS, REACT"}
          projectLink={"https://dovtutis-food-order-app.netlify.app/"}
          codeLink={"https://github.com/Dovtutis/reactFoodOrderApp"}
        />
        <ProjectCard
          name={"Infinite Scrolling Gallery"}
          description={
            "Infinite scrolling gallery with possibility to save favorite pictures. Made by using react." +
            "Images were fetched from Unsplash API. Responsive design implemented for every screen."
          }
          languages={"HTML, CSS, JS, REACT"}
          projectLink={"https://dovtutis-infinte-gallery.netlify.app/"}
          codeLink={"https://github.com/Dovtutis/infiniteScrollingGallery"}
        />
        <ProjectCard
          name={"Simple Recipes Website"}
          description={
            "Simply Recipes is a simple food recipes webpage where user can look for different recipes, check them in detail or select them by tag. It was build by using gatsby and graphql."
          }
          languages={"REACT, GATSBY, GRAPHQL"}
          projectLink={"https://dovtutis-simply-recipes.netlify.app/"}
          codeLink={"https://github.com/Dovtutis/simplyRecipes"}
        />
        <ProjectCard
          name={"Guess a Number Game"}
          description={
            "Guess a number game is a single application where computer is trying to guess a number that you chose, after each guess you give computer a tip, if the number he guessed is higher or lower." +
            "This task was from Udemy REACT Native course. It was created by using React Native (Expo)."
          }
          languages={"REACT NATIVE, JS"}
          projectLink={"https://youtu.be/Hwn0mKv0uFw"}
          codeLink={"https://github.com/Dovtutis/guessANuberGame"}
        />
        <ProjectCard
          name={"Real Estate Sales Website"}
          description={
            "Real estate sales webpage. Front end task which includes responsive design, galery slider, table filtering by specific parameters. Styles writen in SCSS. " +
            "Support for Chrome Firefox and Safari Browsers. Images for gallery fetched from Unsplash API."
          }
          languages={"HTML, CSS, SCSS, JS"}
          projectLink={"https://dovtutis.github.io/ntProject/"}
          codeLink={"https://github.com/Dovtutis/ntProject"}
        />
        <ProjectCard
          name={"Gaming Web Store"}
          description={
            "Video games Web Store with database and full admin/user functionality by using advanced MVC structure. This is v1.00," +
            "more updates will be implemented in the future. This project uses advanced MVC structure with composre and PSR-4 autoloading, MYSQL database."
          }
          languages={"HTML, CSS, JS, PHP"}
          projectLink={"http://gaming-world.epizy.com/main"}
          codeLink={"https://github.com/Dovtutis/gamingWebStore"}
        />
        <ProjectCard
          name={"Quotes with Comments Application"}
          description={
            "Application which allows user to post quotes and add comments." +
            "Quotes and comments are stored in Firebase database. React router and lazy loading was used, also dynamic, nested routes. Separate api function file for handling database requests."
          }
          languages={"HTML, CSS, JS, REACT"}
          projectLink={"https://dovtutisquotesapp.netlify.app/"}
          codeLink={"https://github.com/Dovtutis/quotesWithCommentsApp"}
        />
        <ProjectCard
          name={"Register Login Comment Page"}
          description={
            "Simple webpage with possibility to register an account, login and leave a feedback. This task was a final PHP task for Full Stack Junior" +
            "WEB Developer studies (T43061303). PS design was given in documentation... :)"
          }
          languages={"HTML, CSS, JS, PHP"}
          projectLink={"http://registerlogincomment.epizy.com/"}
          codeLink={"https://github.com/Dovtutis/registerLoginComment"}
        />
        <ProjectCard
          name={"Meetings application - Next.js project"}
          description={
            "Meetings application allows user to browse and create meetings for a specific location" +
            "Core next.js features used like dynamic pages, static props, static paths, server side code, server side rendering for improved SEO, api routes, etc."
          }
          languages={"HTML, CSS, JS, REACT, NEXT.JS"}
          projectLink={"https://meetings-app-xi.vercel.app/"}
          codeLink={"https://github.com/Dovtutis/meetingsApp"}
        />
        <ProjectCard
          name={"Black Jack Game"}
          description={
            "Black Jack Card game with computer AI. Cards deck generated by using deck of cards API"
          }
          languages={"HTML, CSS, JS"}
          projectLink={"https://dovtutis.github.io/BlackJackGame/"}
          codeLink={"https://github.com/Dovtutis/BlackJackGame"}
        />
        {/* <ProjectCard
          name={"Strategy Game"}
          description={
            "Simple strategy game made by using react. Players have three resources, for which they can buy different buildings. Buildings generate resources." +
            "Most of the buildings have requirements, also you can upgrade you buildings, which increases the amount of resources they generate."
          }
          languages={"HTML, CSS, JS, REACT"}
          projectLink={"https://dovtutis-react-strategy-game.netlify.app/"}
          codeLink={"https://github.com/Dovtutis/reactStrategyGame"}
        /> */}
        <ProjectCard
          name={"React Cocktails Search App"}
          description={
            "The Cocktail DB web application allows user to search for cocktails and check information about them in detail (ingredients, instruction for making them, etc)."
          }
          languages={"HTML, CSS, JS, REACT"}
          projectLink={"https://dovtutis-cocktails-search-app.netlify.app/"}
          codeLink={"https://github.com/Dovtutis/cocktails-search-app"}
        />
        <ProjectCard
          name={"Pixel Creation System With Users"}
          description={
            "Pixeletron is a webpage with register and login system, where registered users can add pixels of different size and color to the field which is used by all users." +
            "Created pixels and users are stored in database"
          }
          languages={"HTML, CSS, JS, PHP"}
          projectLink={
            "http://pixeletron.epizy.com/pixeletron/pixels/index/all"
          }
          codeLink={"https://github.com/Dovtutis/pixeletron"}
        />
      </div>
    </div>
  );
}
